import env from "@beam-australia/react-env";

export const CHANNEL_ID_SESSION_NAME = "channelId";

export const SESSION_ID = "session_id";
export const DETECT_UN_ACTIVITY="customer_inactive";
export const CUSTOMER_INACTIVE2="customer_inactive_2nd";
export const TRIGGER_WELCOME_INTENT="welcome_intent_trigger";
export const TRIGGER_DOWNTIME_INTENT="downtime_intent_trigger";
export const CLICKED_WELCOME="clicked_welcome";
export const FEEDBACK_SUCCESS="feedback_success";
export const FEEDBACK_FAIL="feedback_fail";

export const FEEDBACK="feedback";
export const FEEDBACK_SHOW="feedback_show"
export const IP_ADDRESS = "ipAddress";
export const BUDDY_MSG = "buddy_msg";
export const BUDDY_SELECT="buddy_select"
export const USER_MSG = "user_msg";
export const OTP_FORM = "otp_form";
export const NOTICE_MSG = "notice_msg";
export const TIME_MSG = "time_msg";
export const LOAD_HISTORY_MSG = "load_history_msg";
export const LOAD_HISTORY_DATE = "load_history_date";
export const BUDDY_COMMON="buddy_common"
export const FORM_MSG = "form_msg";

export const SELECT_WARNING="please select a chatbot.";
export const EMPTY="";
export const ARTICLE_MSG = "article_msg";
export const COMMONFAQSIZE=5;
export const WELCOME_STRING="query-string-welcome-intent";
export const WELCOME_NAME="welcome"

export const CONFIG = {
    LIVE: (env ("LIVE").toLowerCase() == 'true'),
    MFE_PUBLIC_PATH:env ("MFE_PUBLIC_PATH"),
    USER_PREFERENCE:env("USER_PREFERENCE"),
    GATEWAY_PATH:env ("GATEWAY_PATH"),
    SHOW_SUGGESTION_CHARACTER:env ("SHOW_SUGGESTION_CHARACTER"),
    CHANNEL_ID:env ("CHANNEL_ID"),
    CONVERSATION_EXTERNAL:env("CONVERSATION_EXTERNAL"),
    FULFILLMENT_DOMAIN:env("FULFILLMENT_DOMAIN"),
    INACTIVITY_TIME:env("INACTIVITY_TIME"),
    INACTIVITY_TIME_TEN:env("INACTIVITY_TIME_TEN"),
    FEEDBACK_TIME_TEN:env("FEEDBACK_TIME_TEN"),
    UNACTIVITY_TRIGGER:env("UNACTIVITY_TRIGGER"),
    NOEND_CHAT:env("NOEND_CHAT"),
    NOEND_CHINESE_CHAT:env("NOEND_CHINESE_CHAT"),
    ERROR_MSG:env("ERROR_MSG"),
    TARGET_ORIGIN:env("TARGET_ORIGIN"),
    CHRISTMAS_THEME:(env ("CHRISTMAS_THEME")?.toLowerCase() == 'true'),
    CHRISTMAS_CHANNEL:(env ("CHRISTMAS_CHANNEL")?env ("CHRISTMAS_CHANNEL"):''),
    TYPING_MESSAGE:(env ("TYPING_MESSAGE")?env ("TYPING_MESSAGE"):''),
    DOWNTIME_UTTERANCE:(env ("DOWNTIME_UTTERANCE")?env ("DOWNTIME_UTTERANCE"):''),
    FEEDBACK_DEFAULT_PARAM:env("FEEDBACK_DEFAULT_PARAM"),
    APPD: (env("APPD") == 'true'),
    APPD_CDN: env("APPD_CDN"),
    APPD_APPKEY: env("APPD_APPKEY"),
    APPD_BEACONURL: env("APPD_BEACONURL"),
};



